module.exports = __webpack_public_path__ + "media/images/subcity-logo-horizontal-transparent-3951bb0963b4a971818a0cf1bf291ce4.png";